import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-01ebeca3"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "wrapper-stepper" };
const _hoisted_2 = { key: 0 };
const _hoisted_3 = { class: "stepper" };
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "stepper-progress" }, [
    /*#__PURE__*/ _createElementVNode("div", { class: "stepper-progress-bar" })
], -1));
const _hoisted_5 = ["onClick"];
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "stepper-item-counter" }, null, -1));
const _hoisted_7 = { class: "stepper-item-title" };
import { useMessage } from '@/const/messages';
export default /*#__PURE__*/ _defineComponent({
    props: {
        isShowButton: { type: Boolean },
        steps: null,
        selectedId: null
    },
    emits: ["updateStepperIdByBtn", "updateStepperIdByDirectClick"],
    setup(__props, { emit }) {
        const props = __props;
        const { GOBACK, format } = useMessage();
        const STATUS_COMPLETE = 5;
        const moveBackStepperByReturnButton = () => {
            if (props.selectedId !== STATUS_COMPLETE) {
                emit('updateStepperIdByBtn');
            }
        };
        const moveBackStepperByDirectClick = (id) => {
            if (props.selectedId !== STATUS_COMPLETE) {
                emit('updateStepperIdByDirectClick', id);
            }
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (props.isShowButton)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _createElementVNode("p", {
                            class: "btn-return",
                            onClick: moveBackStepperByReturnButton
                        }, _toDisplayString(_unref(format)(_unref(GOBACK).NOW)), 1)
                    ]))
                    : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_3, [
                    _hoisted_4,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.steps, (label) => {
                        return (_openBlock(), _createElementBlock("div", {
                            key: label.id,
                            class: _normalizeClass([{ current: label.id === props.selectedId, success: label.id < props.selectedId }, "stepper-item"]),
                            onClick: ($event) => (moveBackStepperByDirectClick(label.id))
                        }, [
                            _hoisted_6,
                            _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(format)(label.label)), 1)
                        ], 10, _hoisted_5));
                    }), 128))
                ])
            ]));
        };
    }
});
